var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 208,
    viewBox: "0 0 531 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.684 97.6784H249.567C249.567 97.6784 258.429 68.255 226.36 63.9561C226.36 63.9561 190.323 61.9738 176.106 98.9987L165.87 134.041C165.87 134.041 159.916 161.813 190.333 164.795C190.333 164.795 224.057 169.091 238.933 132.397H217.938C217.938 132.397 210.336 147.769 196.449 144.794C196.449 144.794 183.225 144.456 189.837 124.957L198.763 98.5091C198.763 98.5091 204.054 83.6336 218.269 84.2955C218.269 84.2887 230.504 83.6269 228.684 97.6784Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.456 88.6349L432.017 75.4648C432.017 75.4648 425.219 56.8915 390.628 62.97C390.628 62.97 357.363 70.3993 355.843 102.312C355.843 102.312 354.216 119.139 376.673 122.867C378.772 123.204 380.894 123.378 383.019 123.387C387.939 123.431 401.502 124.62 392.833 136.925C392.833 136.925 380.034 154.148 353.996 136.925L336.098 150.095C336.098 150.095 346.567 173.396 388.105 161.577C388.105 161.577 420.187 152.976 417.908 118.751C417.867 118.17 417.86 117.589 417.854 117.008C417.83 114.036 414.953 103.325 388.004 102.312C388.004 102.312 371.631 100.414 381.83 88.0507C383.287 86.2776 385.119 84.8488 387.193 83.8666C392.603 81.3238 404.072 78.0076 414.456 88.6349Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326.484 164.954L320.405 64.9962H303.489L238.342 164.954H260.016L271.498 148.302H303.493V164.954H326.484ZM302.675 130.046H282.413L302.675 99.1034V130.046Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M456.671 63.6454H523.432L517.121 84.2448H472.536L466.785 103.325H504.956L499.222 124.093H460.163L454.307 144.017H499.205L493.143 164.954H424.953L456.671 63.6454Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M520.308 7.07134C520.308 7.07134 441.116 -8.63149 252.843 21.9299C252.843 21.9299 36.2297 60.2685 5.4273 127.629C3.47707 131.847 2.7001 136.513 3.17816 141.136C4.4986 153.631 13.4783 177.999 61.362 190.122C61.362 190.122 100.199 201.604 138.022 204.981L145.789 175.602C145.789 175.602 63.726 164.795 67.4408 133.052C67.4408 133.052 63.3883 82.3976 279.184 34.1072C279.184 34.087 390.628 7.40903 520.308 7.07134Z",
    fill: "#F5F5F5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77b75ddbc84e65bae013e12738950ca4.svg";
export { ForwardRef as ReactComponent };